<template>
  <div class="d-flex flex-wrap" style="gap: 4px">
    <v-chip v-for="tag in tagNames" :key="tag" small color="secondary" outlined>
      {{ tag }}
      <span v-if="isNewSsdTag(tag) && newSsdCreated" class="ms-1 tag-date text--secondary font-weight-regular">
        {{ newSsdCreated }}
      </span>
    </v-chip>
  </div>
</template>

<script>
import { getConfigTags, getNewSsdDate, isNewSsdTag } from "@/utils/tags"

export default {
  name: "TagChips",

  props: {
    // Either hand over the config the tags belong to and let this work the
    // tags and the New SSD date out...
    config: {
      type: Object,
      default: null,
    },

    // ...or pass them in, for callers that have already worked them out. The
    // reports build theirs from maps shared across every row.
    tags: {
      type: Array,
      default: null,
    },
    newSsdDate: {
      type: String,
      default: "",
    },
  },

  computed: {
    tagNames() {
      return this.tags || getConfigTags(this.config)
    },
    newSsdCreated() {
      return this.config ? getNewSsdDate(this.config) : this.newSsdDate
    },
  },

  methods: { isNewSsdTag },
}
</script>

<style scoped>
/* The created date sits inside the tag chip, so it has to read as a footnote to
   the tag name rather than compete with it. Smaller than .text-xs, which is the
   chip's own size. */
.tag-date {
  font-size: 0.625rem;
  line-height: 1;
}
</style>
